import { useContext } from 'react';
import { PiletApiProvider } from '../context/Provider';

export function usePiletApi() {
  return useContext(PiletApiProvider);
}
